(() => {
  const SELECTOR = '[data-card-variant-preview]';

  const ensureStyles = () => {
    if (document.querySelector('link[data-pedrocchi-product-card-styles]')) return;

    const script = document.currentScript;
    if (!script?.src) return;

    const stylesheetUrl = new URL(script.src);
    stylesheetUrl.pathname = stylesheetUrl.pathname.replace('pedrocchi-product-card.js', 'pedrocchi-product-card.css');
    stylesheetUrl.search = '';

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheetUrl.toString();
    link.dataset.pedrocchiProductCardStyles = 'true';
    document.head.appendChild(link);
  };

  const setActive = (wrapper, button) => {
    wrapper.querySelectorAll(SELECTOR).forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const updateLinks = (wrapper, url) => {
    if (!url) return;
    wrapper.querySelectorAll('.card__heading a').forEach((link) => {
      link.href = url;
    });
  };

  const updateImage = (wrapper, button) => {
    const src = button.dataset.previewSrc;
    if (!src) return;

    const media = wrapper.querySelector('.card__media .media');
    const image = media?.querySelector(':scope > img:first-child');
    if (!media || !image) return;

    media.classList.add('pedrocchi-card-media--switching');

    window.setTimeout(() => {
      image.src = src;
      if (button.dataset.previewSrcset) image.srcset = button.dataset.previewSrcset;
      if (button.dataset.previewAlt) image.alt = button.dataset.previewAlt;

      const secondary = media.querySelector(':scope > img:nth-child(2)');
      if (secondary) secondary.hidden = true;

      wrapper.classList.add('pedrocchi-card-variant-selected');
      media.classList.remove('pedrocchi-card-media--switching');
    }, 110);
  };

  const activatePreview = (button) => {
    const wrapper = button.closest('.product-card-wrapper');
    if (!wrapper) return;

    setActive(wrapper, button);
    updateImage(wrapper, button);
    updateLinks(wrapper, button.dataset.variantUrl);
  };

  const bind = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((button) => {
      if (button.dataset.cardVariantReady === 'true') return;
      button.dataset.cardVariantReady = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        activatePreview(button);
      });
    });
  };

  ensureStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();